module.exports = __webpack_public_path__ + "static/media/checkmark.891e56ca.svg";